// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"chDKPtoAmmvJa0BAE5MSs_0","content":"_2xWWGPcNy7jRzytW7tmXze_0","menu":"_1BHoaPTF14x6_-kHmgXWIF_0","chosen":"_27onHeWk9vSWJ3cKMToi7F_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-058937c8","scoped":false,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/router/Report.vue
// module id = enEi
// module chunks = 0